module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/robu_corporate_website/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#0084F4","theme_color":"#0084F4","display":"minimal-ui","icon":"static/favicon.png"},
    },{
      plugin: require('/var/lib/jenkins/workspace/robu_corporate_website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
